/**
 * @desc 部分付款
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  body: defs.tms.PayRequestPartialPaymentDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/paymentMaster/partialPayment`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
